/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import Request from '@/commons/request'
import Message from "@/components/message";
import Storage from '@/commons/storage';
export default {
    data() {
        return {
            /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
            queryParam: {},
            /* 数据源 */
            desserts: [],
            /* table加载状态 */
            loading: false,
            /* table选中keys*/
            selectedRowKeys: [],
            /* table选中records*/
            selectionRows: [],
            /* 高级查询条件 */
            superQueryParams: "",
            page: {
                pageno: 1,
                limit: 10
            },
            pageData: {},

        }
    },
    created() {
        this.user = Storage.get("_wit_acis_users");
    },
    methods: {
        loadData() {
            if (!this.url.list) {
                Message.toast("请先设置url.list属性", { color: 'warning' });
                return
            }
            var params = this.getQueryParams();//查询条件
            this.loading = true;
            Request.postJson(this.url.list, params).then((res) => {
                Message.loading.hide();
                if (res.meta.success || res.data) {
                    this.desserts = res.data.rows;
                    this.pageData = res.data;
                } else {
                    Message.toast("加载失败", { color: 'warning' });
                }
                this.loading = false;
            })
        },
        getQueryParams() {
            if (!this.queryParam.areaCode) {
                this.queryParam.areaCode = this.user.areaCode;
            }
            var codex = Object.assign({}, this.queryParam);
            var params = {};
            params.pageno = this.page.pageno;
            params.limit = this.page.limit;
            params.codex = codex;
            return params;
        },
        searchQuery() {
            this.page.pageno = 1;
            this.loadData(1);
        },
        onClearSelected() {
            this.selectedRowKeys = [];
            this.selectionRows = [];
        },
        getListPage(page) {
            this.page.pageno = page.pageno
            this.page.limit = page.limit
            this.loadData()
        },
        selectTree(areaCode, isLocal) {
            this.queryParam.areaCode = areaCode;
            this.queryParam.local = isLocal ? "1" : "0";
            this.loadData()
        },

        batchDel: function () {
            if (!this.url.delete) {
                Message.toast('请设置url.delete属性!', { color: 'warning' });
                return
            }
            if (this.selectedRowKeys.length <= 0) {
                Message.toast('请选择一条记录!', { color: 'warning' });
            } else {
                var ids = this.selectedRowKeys.join(",");
                var that = this;
                Message.confirm(
                    { title: '确认删除', text: '是否删除选中数据?' },
                    (result) => {
                        if (result.value) {
                            Request.getForm(that.url.delete, { id: ids }).then((res) => {
                                if (res.meta.success) {
                                    Message.toast('删除成功', { color: 'success' });
                                    that.loadData();
                                    that.onClearSelected();
                                } else {
                                    Message.toast('删除失败', { color: 'warning' });
                                }
                            });
                        }
                    });
            }
        },
        deleteItem: function (id, txt) {
            if (!this.url.delete) {
                Message.toast('请设置url.delete属性!', { color: 'warning' });
                return
            }
            var that = this;
            Message.confirm(
                { title: '确认删除', text: txt ? txt : '是否删除?' },
                (result) => {
                    result && Request.getForm(that.url.delete, { id: id }).then((res) => {
                        if (res.meta.success) {
                            Message.toast('删除成功', { color: 'success' });
                            that.loadData();
                        } else {
                            Message.toast('删除失败', { color: 'warning' });
                        }
                    });
                }
            );

        },
        edit: function (record) {
            this.$refs.modalForm.edit(record);

        },
        add: function () {
            this.$refs.modalForm.add();
        },
        modalFormOk() {
            // 新增/修改 成功时，重载列表
            this.loadData();
        },
        handleDetail: function (record) {
            this.$refs.modalForm.edit(record);
            this.$refs.modalForm.title = "详情";
            this.$refs.modalForm.disableSubmit = true;
        },
        //导出
        expData() {
            this.overlay = true;
            var params = this.getQueryParams();//查询条件
            Request.exp(this.url.exp, params).then((res) => {
                if (res) {
                    const disposition = res.headers['content-disposition'];
                    const filename = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length));
                    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob);
                    } else {
                        const link = document.createElement('a');
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
                this.overlay = false;
            })
        },
    }

}